var _line, _line2, _line3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageCampaignsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.5773,
    y1: 23,
    x2: 4.5773,
    stroke: "#EA5454",
    strokeWidth: 1.76923
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.423,
    y1: 23,
    x2: 13.423,
    stroke: "#EA5454",
    strokeWidth: 1.76923
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 22.2697,
    y1: 23,
    x2: 22.2697,
    stroke: "#EA5454",
    strokeWidth: 1.76923
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5767,
    cy: 11.4995,
    r: 2.65385,
    fill: "#EA5454"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5767,
    cy: 11.4995,
    r: 2.65385,
    fill: "#EA5454"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4234,
    cy: 18.5757,
    r: 2.65385,
    fill: "#EA5454"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4234,
    cy: 18.5757,
    r: 2.65385,
    fill: "#EA5454"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2701,
    cy: 6.19096,
    r: 2.65385,
    fill: "#EA5454"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2701,
    cy: 6.19096,
    r: 2.65385,
    fill: "#EA5454"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.57737,
    cy: 11.4973,
    r: 3.00769,
    stroke: "#EA5454",
    strokeWidth: 2.83077
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4231,
    cy: 18.5774,
    r: 3.00769,
    stroke: "#EA5454",
    strokeWidth: 2.83077
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.2698,
    cy: 6.19261,
    r: 3.00769,
    stroke: "#EA5454",
    strokeWidth: 2.83077
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageCampaignsIcon);
export default __webpack_public_path__ + "static/media/manage-campaigns-icon.29fbdf5784ed37520d310eafbce29b57.svg";
export { ForwardRef as ReactComponent };